import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-supervisor-grid',
  templateUrl: './supervisor-grid.component.html',
  styleUrls: ['./supervisor-grid.component.css']
})
export class SupervisorGridComponent implements OnInit {
  title="Supervisor Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/supervisor/supervisor-grid/supervisor-grid.component.ts